// extracted by mini-css-extract-plugin
var _1 = "styles-module__container___yYwa0";
var _2 = "styles-module__divider___qISiw";
var _3 = "styles-module__header___JPWPE";
var _4 = "styles-module__links___I4ETV";
var _5 = "styles-module__next___Ib98y";
var _6 = "styles-module__previous___Ojnv3";
var _7 = "styles-module__riverClass___WxejI";
var _8 = "styles-module__riverContainer___zLXOD";
var _9 = "styles-module__subTitle___WFaOA";
var _a = "styles-module__titleContainer___aajYp";
export { _1 as "container", _2 as "divider", _3 as "header", _4 as "links", _5 as "next", _6 as "previous", _7 as "riverClass", _8 as "riverContainer", _9 as "subTitle", _a as "titleContainer" }
